<template>
  <div class="chart-box">
    <div class="managers-view" v-if="CheckUserPermission([1, 2, 3, 4, 12])">
      <ul class="main-tabs center-tabs center-ranking-tabs">
        <li
          v-for="tab in rankingTabs"
          :key="tab.id"
          :class="{
            active: selectedRankingTab === tab.alias,
            disabled: shouldDisableRankTab(
              selectedTimeFrameTab,
              selectedDataTab,
              tab.alias
            )
          }"
          @click="selectedRankingTab = tab.alias"
        >
          <span>
            {{ tab.name }}
          </span>
        </li>
      </ul>
      <div class="col-md-2">
        <ul class="main-tabs">
          <li
            class="daily-stats-tabs"
            v-for="tab in statsTabs"
            :key="tab.id"
            :class="{
              active: selectedStatsTab.alias === tab.alias
            }"
            @click="selectedStatsTab = tab"
          >
            <span>
              {{ tab.name }}
            </span>
          </li>
        </ul>
      </div>
      <div class="col-md-8 content-box">
        <ul class="main-tabs center-tabs">
          <li
            v-for="tab in timeFrameTabs"
            :key="tab.id"
            :class="{
              active: selectedTimeFrameTab === tab.alias,
              disabled: shouldDisableTimeTab(tab.alias)
            }"
            @click="selectedTimeFrameTab = tab.alias"
          >
            <span>
              {{ tab.name }}
            </span>
          </li>
        </ul>
        <div v-if="!Array.isArray(report)">
          <div class="time-ranking">
            <table>
              <tr>
                <th>Rank</th>
                <th>
                  {{
                    DataTabs.find(item => item.alias === selectedDataTab).name
                  }}
                </th>
                <th>Profit</th>
                <th>CR</th>
                <th>Deposit ratios</th>
              </tr>
              <tr
                v-for="stat in filterStatsByRanks(
                  report[selectedStatsTab.type][selectedStatsTab.order][
                    selectedTimeFrameTab
                  ][selectedDataTab],
                  selectedDataTab
                )"
                v-bind:key="stat"
                v-if="
                  stat.object['rankings'].find(
                    item => item.id === selectedRankingTab
                  )['rank'] !== '+0' &&
                    stat.object['rankings'].find(
                      item => item.id === selectedRankingTab
                    )['rank'] !== 'new'
                "
              >
                <td>#{{ stat.placement }}</td>
                <td>
                  <span
                    v-if="
                      stat.condition === 'users' &&
                        salesPersonList.find(
                          item => item.id === stat.object['id']
                        )
                    "
                  >
                    {{
                      salesPersonList.find(
                        item => item.id === stat.object["id"]
                      ).full_name
                    }}
                  </span>
                  <span v-if="stat.condition === 'country_id'">
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === stat.object["id"]
                      ).name
                    }}
                  </span>
                  <span
                    v-if="
                      stat.condition !== 'users' &&
                        stat.condition !== 'country_id'
                    "
                  >
                    {{ stat.object["id"] }}
                  </span>
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.object['rankings']"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  <span>
                    {{
                      stat.object.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪
                  </span>
                </td>
                <td>
                  <span>
                    {{
                      stat.object.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%
                  </span>
                </td>
                <td>
                  <span>
                    [ {{ stat.object.total }} | ({{
                      getStatisticRatios(stat.object, stat.object)
                        .deposit_lead_ratio
                    }}) | {{ stat.object.deposits_amount }} | ({{
                      getStatisticRatios(stat.object, stat.object)
                        .deposit_uniques_ratio
                    }}) | {{ stat.object.uniques }} ]
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!--        <ul class="main-tabs center-tabs center-ranking-tabs">-->
        <!--          <li-->
        <!--            v-for="tab in rankingTabs"-->
        <!--            :key="tab.id"-->
        <!--            :class="{-->
        <!--              active: selectedRankingTab === tab.alias,-->
        <!--              disabled: shouldDisableRankTab(-->
        <!--                selectedTimeFrameTab,-->
        <!--                selectedDataTab,-->
        <!--                tab.alias-->
        <!--              )-->
        <!--            }"-->
        <!--            @click="selectedRankingTab = tab.alias"-->
        <!--          >-->
        <!--            <span>-->
        <!--              {{ tab.name }}-->
        <!--            </span>-->
        <!--          </li>-->
        <!--        </ul>-->
      </div>

      <div class="col-md-2">
        <ul class="main-tabs">
          <li
            class="daily-stats-tabs"
            v-for="tab in DataTabs"
            :key="tab.id"
            :class="{
              active: selectedDataTab === tab.alias,
              disabled: shouldDisableDataTab(selectedTimeFrameTab, tab.alias)
            }"
            @click="selectedDataTab = tab.alias"
          >
            <span>
              {{ tab.name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="agents-view">
      <div class="col-md-2">
        <ul class="main-tabs">
          <li
            class="daily-stats-tabs"
            v-for="tab in statsTabs"
            :key="tab.id"
            :class="{ active: selectedStatsTab.alias === tab.alias }"
            @click="selectedStatsTab = tab"
          >
            <span>
              {{ tab.name }}
            </span>
          </li>
        </ul>
      </div>
      <div class="col-md-10 content-box">
        <div v-if="!Array.isArray(report) && checkIfUserInReport()">
          <div
            class="time-ranking"
            v-for="time in [7, 30, 90, 180]"
            v-bind:key="time"
          >
            <span
              class="time-title"
              v-if="
                filterStatsByRanks(
                  report[selectedStatsTab.type][selectedStatsTab.order][time][
                    'users'
                  ],
                  'users'
                ).length > 0
              "
              >LAST {{ time }} DAYS</span
            >
            <table>
              <tr
                v-for="stat in filterStatsByRanks(
                  report[selectedStatsTab.type][selectedStatsTab.order][time][
                    'users'
                  ],
                  'users'
                )"
                v-bind:key="stat"
              >
                <td>#{{ stat.placement }}</td>
                <td>
                  <span
                    v-if="
                      stat.condition === 'users' &&
                        salesPersonList.find(
                          item => item.id === stat.object['id']
                        )
                    "
                  >
                    {{
                      salesPersonList.find(
                        item => item.id === stat.object["id"]
                      ).full_name
                    }}
                  </span>
                  <span v-if="stat.condition === 'country_id'">
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === stat.object["id"]
                      ).name
                    }}
                  </span>
                  <span
                    v-if="
                      stat.condition !== 'users' &&
                        stat.condition !== 'country_id'
                    "
                  >
                    {{ stat.object["id"] }}
                  </span>
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.object['rankings']"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  <span>
                    {{
                      stat.object.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%
                  </span>
                </td>
                <td>
                  <span>
                    [ {{ stat.object.total }} | ({{
                      getStatisticRatios(stat.object, stat.object)
                        .deposit_lead_ratio
                    }}) | {{ stat.object.deposits_amount }} | ({{
                      getStatisticRatios(stat.object, stat.object)
                        .deposit_uniques_ratio
                    }}) | {{ stat.object.uniques }} ]
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "StatsReports.container",
  mixins: [UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },

  data() {
    return {
      reportBusy: false,
      report: [],
      statsTabs: [
        {
          id: 0,
          name: "PROFITS",
          alias: "PROFITS",
          type: "profit",
          order: 1
        },
        {
          id: 1,
          name: "LOST",
          alias: "LOST",
          type: "profit",
          order: 0
        },
        {
          id: 2,
          name: "CR",
          alias: "CR",
          type: "conversion",
          order: 1
        },
        {
          id: 3,
          name: "UN-CR",
          alias: "LOST_CR",
          type: "conversion",
          order: 0
        }
      ],
      selectedStatsTab: {
        id: 0,
        name: "PROFITS",
        alias: "PROFITS",
        type: "profit",
        order: 1
      },
      timeFrameTabs: [
        {
          id: 0,
          name: "7 DAYS",
          alias: "7"
        },
        {
          id: 1,
          name: "30 DAYS",
          alias: "30"
        },
        {
          id: 2,
          name: "90 DAYS",
          alias: "90"
        },
        {
          id: 3,
          name: "180 DAYS",
          alias: "180"
        }
      ],
      selectedTimeFrameTab: "7",
      DataTabs: [
        {
          id: 0,
          name: "USERS",
          alias: "users"
        },
        {
          id: 1,
          name: "KEYWORDS",
          alias: "keyword"
        },
        {
          id: 2,
          name: "CAMPAIGNS",
          alias: "campaign_aaid"
        },
        {
          id: 3,
          name: "COUNTRIES",
          alias: "country_id"
        }
      ],
      selectedDataTab: "users",
      rankingTabs: [
        {
          id: 0,
          name: "D",
          alias: "D"
        },
        {
          id: 1,
          name: "W",
          alias: "W"
        },
        {
          id: 2,
          name: "M",
          alias: "M"
        },
        {
          id: 3,
          name: "Q",
          alias: "Q"
        },
        {
          id: 4,
          name: "H",
          alias: "H"
        },
        {
          id: 5,
          name: "Y",
          alias: "Y"
        }
      ],
      selectedRankingTab: "D"
    };
  },
  created() {
    this.getPerformanceByDate();
  },
  watch: {
    selectedStatsTab: function() {
      this.whichTimeTabToPresent();
    },
    selectedTimeFrameTab: function() {
      this.whichDataTabToPresent();
    },
    selectedDataTab: function() {
      this.whichRankingTabToPresent();
    }
  },
  methods: {
    async getPerformanceByDate() {
      const res = await apiClientCreator(
        `reports/campaigns/performance/previousStats`
      ).get("");
      try {
        this.report = res.data;
        this.whichTimeTabToPresent();
      } catch (e) {}
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    filterStatsByRanks(stats, cond) {
      let filteredStats = [];
      for (let key in stats) {
        for (let rank in stats[key]["rankings"]) {
          if (
            stats[key]["rankings"][rank]["rank"] !== "new" &&
            stats[key]["rankings"][rank]["rank"] !== "+0"
          ) {
            let stat = {
              placement: parseInt(key) + 1,
              object: stats[key],
              condition: cond
            };
            filteredStats.push(stat);
            break;
          }
        }
      }
      return filteredStats;
    },
    getStatisticRatios(primary, secondary) {
      let ratios = {
        profit_ratio: 0,
        deposit_lead_ratio: 0,
        deposit_uniques_ratio: 0
      };
      if (secondary.profit !== 0) {
        ratios.profit_ratio =
          Math.abs((secondary.profit / primary.profit) * 100).toFixed(1) + "%";
      }
      if (secondary.total !== 0) {
        ratios.deposit_lead_ratio =
          Math.abs((secondary.deposits_amount / secondary.total) * 100).toFixed(
            1
          ) + "%";
      }
      if (secondary.uniques !== 0) {
        ratios.deposit_uniques_ratio = Math.abs(
          secondary.deposits_amount / secondary.uniques
        ).toFixed(1);
      }
      return ratios;
    },
    checkIfUserInReport() {
      for (let time of [7, 30, 90, 180]) {
        let filteredUsers = this.filterStatsByRanks(
          this.report[this.selectedStatsTab.type][this.selectedStatsTab.order][
            time
          ]["users"],
          "users"
        );
        if (filteredUsers.find(item => item.object.id === this.auth.user.id)) {
          return true;
        }
      }
      return false;
    },
    shouldDisableRankTab(timeTab, dataTab, tab) {
      if (!Array.isArray(this.report)) {
        let stats = this.filterStatsByRanks(
          this.report[this.selectedStatsTab.type][this.selectedStatsTab.order][
            timeTab
          ][dataTab],
          dataTab
        );
        for (let stat of stats) {
          if (
            stat.object["rankings"].find(item => item.id === tab)["rank"] !==
              "+0" &&
            stat.object["rankings"].find(item => item.id === tab)["rank"] !==
              "new"
          ) {
            return false;
          }
        }
        return true;
      }
    },
    shouldDisableDataTab(timeTab, tab) {
      if (!Array.isArray(this.report)) {
        let stats = this.report[this.selectedStatsTab.type][
          this.selectedStatsTab.order
        ][timeTab][tab];
        for (let stat of stats) {
          for (let rank of stat["rankings"]) {
            if (!this.shouldDisableRankTab(timeTab, tab, rank["id"])) {
              return false;
            }
          }
        }
        return true;
      }
    },
    shouldDisableTimeTab(tab) {
      if (!Array.isArray(this.report)) {
        let stats = this.report[this.selectedStatsTab.type][
          this.selectedStatsTab.order
        ][tab];
        for (let [key, value] of Object.entries(stats)) {
          if (!this.shouldDisableDataTab(tab, key)) {
            return false;
          }
        }
        return true;
      }
    },
    whichTimeTabToPresent() {
      for (let item of this.timeFrameTabs) {
        if (!this.shouldDisableTimeTab(item.alias)) {
          this.selectedTimeFrameTab = item.alias;
          this.whichDataTabToPresent();
          break;
        }
      }
    },
    whichDataTabToPresent() {
      for (let item of this.DataTabs) {
        if (!this.shouldDisableDataTab(this.selectedTimeFrameTab, item.alias)) {
          this.selectedDataTab = item.alias;
          this.whichRankingTabToPresent();
          break;
        }
      }
    },
    whichRankingTabToPresent() {
      for (let item of this.rankingTabs) {
        if (
          !this.shouldDisableRankTab(
            this.selectedTimeFrameTab,
            this.selectedDataTab,
            item.alias
          )
        ) {
          this.selectedRankingTab = item.alias;
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
table tr:nth-of-type(2n) {
  background: #f5f7ff;
}
table tr:hover {
  background: #eceff1;
}
table {
  width: 100%;
}
table,
th,
td {
  border-collapse: collapse;
  vertical-align: top;
  padding: 0.1em 0.7em;
}
.chart-box {
  display: flex;
  background-color: white;
  justify-content: space-between;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  max-height: 200px;
  min-height: 200px;
}
.main-tabs {
  max-width: 16%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 2;
}

.main-tabs.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0 0;
  transition: transform 0.1s ease;
}

.main-tabs li {
  font-size: 0.7vw;
  max-width: 100%;
  min-width: 92px;
  height: 25px;
  cursor: pointer;
  background: white;
  border-radius: 0;
  text-align: left;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  transition: background 0.2s ease, color 0.2s ease;
}

.main-tabs li:not(.empty):hover {
  transform: translateY(1px);
}

.main-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.center-tabs {
  flex-direction: row !important;
  max-width: 100% !important;
}
.center-tabs li {
  text-align: center !important;
}
.daily-stats-tabs {
  display: flex;
  justify-content: space-between;
}
.daily-camp-report-tab {
  font-size: 0.75vw;
  height: 260px;
  display: flex;
  overflow-y: scroll;
  flex: 3;
  flex-direction: column;
  padding-left: 1em;
}
.report-rank {
  font-size: 0.6vw;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.time-ranking {
  padding-top: 0.5em;
}
.time-title {
  font-weight: bold;
  padding: 1em 0 1em 0;
}
.center-ranking-tabs {
  display: flex;
  flex-direction: column !important;
  position: absolute;
  width: 1%;
  left: 12px;
  bottom: 38px;
}
.center-ranking-tabs li {
  font-size: 10px;
  background: none !important;
  max-width: 10px !important;
  min-width: 5px !important;
}
.center-ranking-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}
.content-box {
  height: 180px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.agents-view .content-box {
  overflow-y: scroll;
}
.agents-view,
.managers-view {
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}
.disabled {
  pointer-events: none;
  opacity: 0.2;
}
::-webkit-scrollbar {
  display: none;
}
</style>
